import { Router } from '@angular/router';

const reloadComponent = (router: Router): void => {
  const currentUrl = router.url;
  router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    router.navigate([currentUrl]);
  });
};

export const url = {
  reloadComponent,
};
